"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPlayersSaga = fetchPlayersSaga;
exports.playersProviderSaga = playersProviderSaga;
const effects_1 = require("redux-saga/effects");
const LanguagesProvider_1 = require("../LanguagesProvider");
const players_1 = require("../../api/players");
const slice_1 = require("./slice");
const selectors_1 = require("./selectors");
function* fetchPlayersSaga(action) {
    try {
        const { playersIds } = action.payload;
        if (playersIds.length) {
            const unknownPlayerIds = yield (0, effects_1.select)(selectors_1.selectUnknownPlayerIds, playersIds);
            if (unknownPlayerIds.length) {
                const locale = yield (0, effects_1.select)(LanguagesProvider_1.selectCurrentLangCode);
                const { data: { items: players }, } = yield (0, effects_1.call)(players_1.getPlayers, {
                    locale,
                    ids: unknownPlayerIds,
                });
                yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayersSuccess({ players }));
            }
            else {
                yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayersStopped());
            }
        }
        else {
            yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayersStopped());
        }
    }
    catch (e) {
        console.error('Error occurred while fetching players', e);
        yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayersError(e));
    }
}
function* playersProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeEvery)(slice_1.playersProviderActions.fetchPlayers.type, fetchPlayersSaga),
    ]);
}
//# sourceMappingURL=saga.js.map